// extracted by mini-css-extract-plugin
export default {"spinnerWrapper":"VenuesPage_spinnerWrapper__vCy0k","page":"VenuesPage_page__hIYqs","wrapper":"VenuesPage_wrapper__tw+R8"};